import React, { useState, useEffect } from 'react';
import { navigate, useLocation } from '@reach/router';
import { useSelector } from 'react-redux';
import './DashboardHeader.scss';
import { RootState } from '@/redux/reducers';
import AuthDropdown from '@/containers/AuthDropdown/AuthDropdown';
import IconSmallPlus from '@/assets/icons/small-plus.svg';
import IconUser from '@/assets/icons/user-black.svg';
import { addButtons } from './DashboardHeader.data';

interface DashboardHeaderProps {}

const DashboardHeader: React.FC<DashboardHeaderProps> = () => {
  const authUser = useSelector((state: RootState) => state.authUser.data);
  const { userInfo } = useSelector((state: RootState) => state.membershipUsers);
  const organisation = useSelector((state: RootState) => state.serviceDirectoryEntity.entityDashboard);
  // const [newNoti] = useState<boolean>(true);
  const { pathname } = useLocation();
  const [buttonAddNew, setButtonAddNew] = useState<{
    label: string;
    handleClick: Function;
    show: boolean;
  }>({
    label: '',
    handleClick: () => {},
    show: false,
  });

  const checkPermission = (requiredRoles: string[], userRoles?: string[]) => {
    if (userRoles) {
      const checkRoles = userRoles.map((role) => requiredRoles.includes(role));
      const hasPermission = checkRoles.includes(true) || !requiredRoles.length;
      return hasPermission;
    }
    return true;
  };

  const handleClickButtonAdd = (pagePath?: string, actionPath?: string) => {
    if (pagePath && actionPath) {
      const newPath = `/dashboard/${pagePath}/${actionPath}`;
      navigate(newPath);
    }
  };

  useEffect(() => {
    const matchButton = addButtons.find((button) => button.regex.test(pathname));
    if (authUser) {
      const roles = !userInfo.memberships.length
        ? authUser?.roles
        : [
            ...authUser?.roles,
            userInfo.memberships.find((entity) => entity.organisationId === organisation?.id)?.roleName || '',
          ];
      setButtonAddNew({
        label: matchButton?.label ?? '',
        handleClick: () => handleClickButtonAdd(matchButton?.pagePath, matchButton?.actionPath),
        show: checkPermission(matchButton?.requiredRoles || [], roles),
      });
    }
    // eslint-disable-next-line
  }, [pathname]);

  return (
    <div className="DashboardHeader">
      <div className="DashboardHeader-addNewBtnWrapper">
        {buttonAddNew.label && buttonAddNew.show && (
          <button className="DashboardHeader-addNewBtn" onClick={() => buttonAddNew.handleClick()} type="button">
            <img src={IconSmallPlus} alt="Open Banking" />
            <span>{buttonAddNew.label}</span>
          </button>
        )}
      </div>
      {authUser && (
        <div className="DashboardHeader-info">
          <AuthDropdown
            iconUser={IconUser}
            textColor="#000000"
            componentNotLoginYet={
              <div className="Navbar-logout">
                <span>Login</span>
              </div>
            }
          />
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
